
/* injects from baggage-loader */

angular.module('siter.io').factory('WidgetsSortHelper', [() => {
  return {
      sortWidgetsByTypesSortMap: function(widgetsArray, widgetsTypesSortMap) {
          return this.sortByMap(widgetsArray, widgetsTypesSortMap, 'type');
      },

      sortWidgetsByName: function(widgetsArray) {
          widgetsArray.sort((a, b) => {
            return a.name.localeCompare(b.name) * -1;
          });

          return widgetsArray;
      },

      sortByMap: function(objectsArray, mapArray, key) {
          objectsArray.sort((a, b) => {
              const aKey = a[key];
              const bKey = b[key];

              return mapArray.indexOf(aKey) > mapArray.indexOf(bKey) ? 1 : -1;
          });

          return objectsArray;
      },
  };
}]);



// WEBPACK FOOTER //
// ./src/app/common/services/widgetsSortHelper.service.js